import * as xl from 'xlsx/xlsx.mjs';

import React, { useEffect, useState } from "react";
import {
    flipButton,
    flipButtonAnchor,
} from '../pages/index.module.css'

import { DisplayHoursWithFormat } from './DisplayHours'
import { useTerminology } from "utils";

// import xlsx from "json-as-xlsx";






const DataExport = ({ sites, settings, staff, equipment, view, csvColumns }) => {
    const { siteLabel } = useTerminology();

    const handleExport = () => {
        let workbook = xl.utils.book_new();

        workbook.Props = {
            Title: 'Timesheet Report',
            Subject: 'Timesheet Report',
            Author: 'SafetyWise',
            CreatedDate: new Date(),
        };

        let worksheetStaffData = [];
        let worksheetSiteData = [];
        let worksheetEquipmentData = [];


        Object.keys(staff).forEach(_staff => {
            worksheetStaffData = [...worksheetStaffData, ...table_staffMember(staff[_staff], _staff, settings, siteLabel, csvColumns)];
        })
        Object.keys(sites).forEach(_site => {
            worksheetSiteData = [...worksheetSiteData, ...table_site(sites[_site], _site, settings, siteLabel, csvColumns)]
        })
        if (equipment) {
            Object.keys(equipment).forEach(_equipment => {
                worksheetEquipmentData = [...worksheetEquipmentData, ...table_site(equipment[_equipment], _equipment, settings, siteLabel, csvColumns)]
            })
        }


        let worksheetStaff = xl.utils.aoa_to_sheet(worksheetStaffData);
        let worksheetSite = xl.utils.aoa_to_sheet(worksheetSiteData);

        var wscols = [
            { wch: 25 },
            { wch: 25 },
            { wch: 25 }, //? 'Start Time'
            { wch: 25 }, //? 'End Time'
            { wch: 25 }, //? 'Site'
            { wch: 25 }, //? 'Notes'
            { wch: 25 }, //? 'Staff Type'
            { wch: 25 }, //? 'Work Type'
            { wch: 25 }, //? 'Equipment'
            { wch: 25 }, //? 'Start Geo'
            { wch: 25 }, //? 'End Geo'
            { wch: 25 }, //? 'Gross Hours'
            { wch: 25 }, //? 'Breaks'
            { wch: 25 }, //? 'Net Hours'
        ];

        worksheetStaff['!cols'] = wscols;
        worksheetSite['!cols'] = wscols;
        
        xl.utils.book_append_sheet(workbook, worksheetStaff, "Staff")
        xl.utils.book_append_sheet(workbook, worksheetSite, siteLabel)
        if (equipment && Object.keys(equipment).length > 0) {
            let worksheetEquipment = xl.utils.aoa_to_sheet(worksheetEquipmentData);
            worksheetEquipment['!cols'] = wscols;
            xl.utils.book_append_sheet(workbook, worksheetEquipment, "Equipment")
        }


        const out = xl.write(workbook, { bookType: 'xlsx', bookSST: true, type: 'binary' })
        let url = window.URL.createObjectURL(new Blob([s2ab(out)], { type: 'application/octet-stream' }))

        // console.log(staff)
        console.log(worksheetSiteData);
        console.log(worksheetStaffData);

        // return;
        let a = document.createElement('a');
        a.href = url;
        a.download = 'Report.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

    }


    const handleCsvExport = () => {
        let csvData = [];

        if (view === 'staff' || !view) {
            Object.keys(staff).forEach(_staff => {
                csvData = [...csvData, ...table_staffMember(staff[_staff], _staff, settings, siteLabel, csvColumns)];
            });
        } else if (view === 'equipment') {
            if (equipment) {
                Object.keys(equipment).forEach(_eq => {
                    csvData = [...csvData, ...table_site(equipment[_eq], _eq, settings, siteLabel, csvColumns)];
                });
            }
        } else {
            Object.keys(sites).forEach(_site => {
                csvData = [...csvData, ...table_site(sites[_site], _site, settings, siteLabel, csvColumns)];
            });
        }

        const csvContent = csvData.map(row =>
            row.map(cell => {
                const str = (cell == null ? '' : String(cell));
                return str.includes(',') || str.includes('"') || str.includes('\n')
                    ? '"' + str.replace(/"/g, '""') + '"'
                    : str;
            }).join(',')
        ).join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Report.csv';
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <span>
            <a onClick={() => handleExport()} className={flipButtonAnchor}>XSLX</a>
            &nbsp;or&nbsp;
            <a onClick={() => handleCsvExport()} className={flipButtonAnchor}>CSV</a>
        </span>
    )
}

function s2ab(s) {
    const buf = new ArrayBuffer(s.length)

    const view = new Uint8Array(buf)

    for (let i = 0; i !== s.length; ++i)
        view[i] = s.charCodeAt(i) & 0xFF

    return buf
}

const hasCustomCsvColumns = (csvColumns) =>
    Array.isArray(csvColumns) && csvColumns.length > 0;

// Detail columns follow the on-screen format settings. When the organisation has
// chosen a Timesheet CSV field list, only those fields are included as well.
export const reportDetailColumns = (settings = {}, siteLabel = "Site", csvColumns = null) => {
    const allowed = hasCustomCsvColumns(csvColumns)
        ? new Set(csvColumns.map((key) => String(key).toLowerCase()))
        : null;
    const include = (...keys) =>
        !allowed || keys.some((key) => allowed.has(String(key).toLowerCase()));

    const columns = [];
    const add = (header, pick, ...keys) => {
        if (include(...keys)) columns.push({ header, pick });
    };

    add("Start Time", (record) => record.start, "StartDate", "StartTime");
    add("End Time", (record) => record.end, "EndDate", "EndTime");
    add(siteLabel, (record) => record.site, "SiteOrLeaveType");

    if (settings.showNotes !== false) add("Notes", (record) => record.notes, "Notes");
    if (settings.showStaffType !== false) add("Staff Type", (record) => record.staffType, "StaffType");
    if (settings.showTaskType !== false) add("Work Type", (record) => record.taskType, "TaskType");
    if (settings.showEquipment !== false) add("Equipment", (record) => record.equipment || "-", "Equipment");
    if (settings.showGeolocation !== false) {
        add("Start Geo", (record) => record.geoStart, "StartGeolocation");
        add("End Geo", (record) => record.geoEnd, "EndGeolocation");
    }
    // Gross hours and rounded hours are report-only columns. A custom CSV field
    // list has no keys for them, so they stay out of that download.
    if (settings.showGrossHours !== false && !allowed) {
        columns.push({
            header: "Gross Hours",
            pick: (record) => DisplayHoursWithFormat(record.hours, settings),
        });
    }
    if (settings.showLunch !== false) add("Breaks", (record) => record.lunch, "LunchTime");
    if (settings.showNetHours !== false) {
        add("Net Hours", (record) => DisplayHoursWithFormat(record.netHours, settings), "NetHours");
    }
    if (settings.roundingEnabled === true && !allowed) {
        columns.push({
            header: "Rounded",
            pick: (record) => DisplayHoursWithFormat(record.roundedNetHours || 0, settings),
        });
    }

    return columns;
};

const table_staffMember = (staff, name, settings, siteLabel = "Site", csvColumns = null) => {
    const showRounding = settings.roundingEnabled === true && !hasCustomCsvColumns(csvColumns);
    const columns = reportDetailColumns(settings, siteLabel, csvColumns);
    const out = [];
    out.push([name, `Total: ${DisplayHoursWithFormat(staff.total, settings)}`, ...(showRounding ? [`Rounded Total: ${DisplayHoursWithFormat(staff.roundedTotal || 0, settings)}`] : [])])
    out.push([])
    out.push(['', ...columns.map((column) => column.header)])
    staff.records.forEach(record => {
        out.push(['', ...columns.map((column) => column.pick(record))])
    })

    return out;
}

const table_site = (site, name, settings, siteLabel = "Site", csvColumns = null) => {
    const showRounding = settings.roundingEnabled === true && !hasCustomCsvColumns(csvColumns);
    const columns = reportDetailColumns(settings, siteLabel, csvColumns);
    const out = [];
    out.push([name, `Total: ${DisplayHoursWithFormat(site.total, settings)}`, ...(showRounding ? [`Rounded Total: ${DisplayHoursWithFormat(site.roundedTotal || 0, settings)}`] : [])])
    out.push([])
    Object.keys(site.staff).forEach((_staff) => {

        out.push([''])
        out.push(['', _staff, `Total: ${DisplayHoursWithFormat(site.staff[_staff].total, settings)}`, ...(showRounding ? [`Rounded: ${DisplayHoursWithFormat(site.staff[_staff].roundedTotal || 0, settings)}`] : [])])

        out.push(['', '', ...columns.map((column) => column.header)])

        site.staff[_staff].records.forEach(record => {
            out.push(['', '', ...columns.map((column) => column.pick(record))])

        })
    })

    // if(settings.siteOrder == 'asc') {
    //   out = out.sort((a, b) =>
    //     a.site > b.site ? 1 : -1,
    //   );
    // }else {
    //   out = out.sort((a, b) =>
    //     a.site > b.site ? 1 : 1,
    //   );
    // }
    return out;
}


const cleanString = (input) => {
    const replaceMap = {
        "\/": "\|",
        "\\": "\|",
        "[": "(",
        "]": ")",
        "?": "",
        "*": ""
    }

    let output = input;
    Object.keys(replaceMap).forEach(_pre => {
        output = output.replace(_pre, replaceMap[_pre]);
    })
    output = output.trim().split('').slice(0, 10).join('');

    return output;

}


export default DataExport;